<script lang="ts">
  /* TEMPORARY DIAGNOSTIC: On-screen tap event logger for iOS debugging.
   * Shows the last 5 pointer/touch/click events so we can see if taps
   * are reaching the buttons. Remove after diagnosis. */
  import { onMount } from 'svelte';

  let events = $state<string[]>([]);
  let panelState = $state('?');

  function log(msg: string) {
    const t = new Date().toLocaleTimeString();
    events = [`${t} ${msg}`, ...events].slice(0, 5);
  }

  onMount(() => {
    const opts = { capture: true, passive: true };
    const onPointerDown = (e: Event) => {
      const t = e.target as HTMLElement;
      const label = t.closest('button')?.getAttribute('aria-label') || t.tagName;
      log(`pointerdown on ${label}`);
    };
    const onTouchStart = (e: Event) => {
      const t = e.target as HTMLElement;
      const label = t.closest('button')?.getAttribute('aria-label') || t.tagName;
      log(`touchstart on ${label}`);
    };
    const onClick = (e: Event) => {
      const t = e.target as HTMLElement;
      const label = t.closest('button')?.getAttribute('aria-label') || t.tagName;
      log(`CLICK on ${label}`);
    };
    document.addEventListener('pointerdown', onPointerDown, opts);
    document.addEventListener('touchstart', onTouchStart, opts);
    document.addEventListener('click', onClick, opts);

    // Poll panel state
    const interval = setInterval(() => {
      // Access via window for debugging
      const w = window as any;
      if (w.__panels) panelState = w.__panels.open ?? 'null';
    }, 500);

    log('debug overlay ready - tap buttons');
    return () => {
      document.removeEventListener('pointerdown', onPointerDown, opts);
      document.removeEventListener('touchstart', onTouchStart, opts);
      document.removeEventListener('click', onClick, opts);
      clearInterval(interval);
    };
  });
</script>

<div class="tap-debug">
  <div class="tap-debug-title">TAP DEBUG (panel: {panelState})</div>
  {#each events as ev}
    <div class="tap-debug-ev">{ev}</div>
  {/each}
</div>

<style>
  .tap-debug {
    position: fixed;
    top: 60px;
    left: 8px;
    right: 8px;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.85);
    color: #0f0;
    font-family: monospace;
    font-size: 11px;
    padding: 8px;
    border-radius: 8px;
    pointer-events: none;
    max-height: 150px;
    overflow: hidden;
  }
  .tap-debug-title {
    font-weight: bold;
    margin-bottom: 4px;
    color: #ff0;
  }
  .tap-debug-ev {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
